import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http'
import { Injectable } from '@angular/core'
import {CUSTOMER_SEARCH_PAGE_NORMALIZER} from "@spartacus/asm/core";
import { OccAsmAdapter } from '@spartacus/asm/occ'
import {AsmConfig, CustomerSearchOptions, CustomerSearchPage} from '@spartacus/asm/root'
import {BaseSiteService, ConverterService, normalizeHttpError, OccEndpointsService} from '@spartacus/core'
import { Observable } from 'rxjs'
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EbAsmAdapter extends OccAsmAdapter {
  protected ebActiveBaseSite: string;
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService,
    protected config: AsmConfig,
    protected baseSiteService: BaseSiteService

) {
    super(http, occEndpointsService, converterService, config, baseSiteService)
    this.baseSiteService
      .getActive()
      .subscribe((value) => (this.ebActiveBaseSite = value));
  }

  loadAsmClientSession(userId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(
      this.occEndpointsService.buildUrl('loadAsmClientSession'),
      userId,
      {
        headers
      }
    )
  }

  setAgentSession(agentId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(
      this.occEndpointsService.buildUrl('setAgentSession'),
      JSON.stringify(agentId),
      {
        headers
      }
    )
  }

  logoutAsmAgent(returningToCustomerSession: boolean): Observable<any> {
    console.log("test232")
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(
      this.occEndpointsService.buildUrl('logoutAsmAgent'),
      returningToCustomerSession,
      { headers }
    )
  }

  logoutAsmCustomer(): Observable<any> {
    return this.http.post(this.occEndpointsService.buildUrl('asmCustomerLogout'), {})
  }
  customerSearch(
    options: CustomerSearchOptions
  ): Observable<CustomerSearchPage> {
    console.log("this is a rest 1")
    const headers = this.getHeaders();
    let query : string;
    let orderId: string;
    let customerListId: string;
    let params: HttpParams = new HttpParams().set(
      'baseSite',
       this.ebActiveBaseSite
    );

    if (options.sort !== undefined) {
      params = params.set('sort', options.sort);
    } else {
      if (!options.customerListId) {
        params = params.set('sort', 'byNameAsc');
      }
    }

    if (options.query !== undefined) {
      query =  options.query;
    }
    if (options.orderId !== undefined) {
      orderId = options.orderId;
    }

    if (options.pageSize !== undefined) {
      params = params.set('pageSize', options.pageSize.toString());
    }

    if (options.currentPage !== undefined) {
      params = params.set('page', options.currentPage.toString());
    }

    if (options.customerListId !== undefined) {
      customerListId = options.customerListId;
    }

    const url = this.occEndpointsService.buildUrl(
      'asmCustomerSearch',
      {},
      {
        baseSite: false,
        prefix: false,
      }
    );

    console.log("this is a rest")
    return this.http.post<CustomerSearchPage>(url, {query, orderId, customerListId  },{ headers, params }).pipe(
      catchError((error) => {
        throw normalizeHttpError(error, this.logger);
      }),
      this.converterService.pipeable(CUSTOMER_SEARCH_PAGE_NORMALIZER)
    );
  }
}
